(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResponseDetailController', SurveyResponseDetailController);

    SurveyResponseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SurveyResponse', 'BatteryTest', 'Patient', 'Question'];

    function SurveyResponseDetailController($scope, $rootScope, $stateParams, entity, SurveyResponse, BatteryTest, Patient, Question) {
        var vm = this;
        vm.surveyResponse = entity;
        vm.load = function (id) {
            SurveyResponse.get({id: id}, function(result) {
                vm.surveyResponse = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:surveyResponseUpdate', function(event, result) {
            vm.surveyResponse = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
